import AppLayout from "@layout/AppLayout";
import AllChallengesPage from "@pages/AllChallenges";
import BadgeDetailsPage from "@pages/BadgeDetails";
import ChallengeDetailsPage from "@pages/ChallengeDetails";
import DashboardPage from "@pages/Dashboard";
import HistoryPage from "@pages/History";
import { createBrowserRouter, createMemoryRouter } from "react-router-dom";

const routes = [
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: "gamification/all-in-progress",
        element: <AllChallengesPage isInProgress />,
      },
      {
        path: "gamification/all-challenges",
        element: <AllChallengesPage />,
      },
      {
        path: "gamification/details/:challengeId",
        element: <ChallengeDetailsPage />,
      },
      {
        path: "gamification/badgeDetails/:challengeId",
        element: <BadgeDetailsPage />,
      },
      {
        path: "gamification/history",
        element: <HistoryPage />,
      },
    ],
  },
];

const isInIframe = globalThis.self !== globalThis.top;
const isDev = process.env.NODE_ENV === "development";

// Use BrowserRouter in dev standalone mode, MemoryRouter in iframe or production
const router = isDev && !isInIframe 
  ? createBrowserRouter(routes)
  : createMemoryRouter(routes);

export default router;
